export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_COUNTRIES_FETCHING_STATE = 'SET_COUNTRIES_FETCHING_STATE';
export const SET_REGIONS = 'SET_REGIONS';
export const SET_REGIONS_FETCHING_STATE = 'SET_REGIONS_FETCHING_STATE';
export const SET_DISTRICTS = 'SET_DISTRICTS';
export const SET_DISTRICTS_FETCHING_STATE = 'SET_DISTRICTS_FETCHING_STATE';